// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__8zaEC","formContainer":"Contact_formContainer__7SV-t","submitButton":"Contact_submitButton__1bKg0"};